import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/RootState'
import { initialState } from './slice'

const selectTmdbState = (state: RootState) => state.Tmdb || initialState

export const tmdbSelector = createSelector([selectTmdbState], Tmdb => Tmdb)
